import type { SagaIterator } from 'redux-saga'

import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import { AGENCY_JOBS_HISTORY_FETCH_BEGIN } from './action-types'
import { listAgencyJobsHistory } from './api'

export function* saga(): SagaIterator {
  yield takeLatestApiCall(AGENCY_JOBS_HISTORY_FETCH_BEGIN, listAgencyJobsHistory)
}
